/* PagingActivityFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

const mongoDbQuery = {
    $or: [
        {
            activityType: "custom",
        },
        {
            activityType: "create",
        },
        {
            activityType: "update",
        },
        {
            activityType: "remove",
        },
        {
            activityType: "relAdd",
        },
        {
            activityType: "relSet",
        },
        {
            activityType: "jobStatus",
        },
        {
            activityType: "provStatus",
        },
    ],
};

class PagingActivityFeed extends PagingFeed {
    _getFeed() {
        const filter = {};
        filter.$and = [this._filter || {}, mongoDbQuery];
        return this._EntityDef.startRelatedAuditsFeed(filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2,
        });
    }

    _feedReestablish() {
        const filter = {};
        filter.$and = [this._filter || {}, mongoDbQuery];
        return this._feed.reestablishFeed(
            this._userSession.activeOrganization.id,
            filter,
            this._entityFields,
            this._sort
        );
    }

    _feedShutDown() {
        return this._EntityDef.stopRelatedAuditsFeed();
    }
}

module.exports = PagingActivityFeed;
